import { useState, useEffect } from 'react';

export const ASPECT_RATIO = 16 / 9;
export const PADDING = 48;
export const MAX_WIDTH = 1600;
export const MAX_HEIGHT = 900;

interface ImageDimensionsProps {
    maxWidth?: number;
    maxHeight?: number;
}

export const useImagePreviewDimensions = ({ maxWidth = MAX_WIDTH, maxHeight = MAX_HEIGHT }: ImageDimensionsProps = {}) => {
    const [dimensions, setDimensions] = useState<{
        width: number;
        height: number;
    }>({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        const calculateDimensions = () => {
            const windowWidth = window.innerWidth - PADDING * 2;
            const windowHeight = window.innerHeight - PADDING * 2;

            let width = windowWidth;
            let height = width / ASPECT_RATIO;

            if (height > windowHeight) {
                height = windowHeight;
                width = height * ASPECT_RATIO;
            }

            if (width > maxWidth) {
                width = maxWidth;
                height = maxWidth / ASPECT_RATIO;
            }

            if (height > maxHeight) {
                height = maxHeight;
                width = maxHeight * ASPECT_RATIO;
            }

            setDimensions({
                width: Math.floor(width),
                height: Math.floor(height),
            });
        };

        calculateDimensions();

        window.addEventListener('resize', calculateDimensions);
        return () => window.removeEventListener('resize', calculateDimensions);
    }, [maxWidth, maxHeight]);

    return dimensions;
};
